import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Infrastructure = () => {
      useEffect(() => {
        document.title = 'Infrastructure -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Infrastructure </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Infrastructure  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
          {/* <div class="table-responsive maintable">
               <table class="table">
               <thead> 
               <tr>
                   <th>S.NO.</th>
                   <th>Room</th>
                   <th>Number</th>
               </tr>
           </thead>
           <tbody>
           <tr>
               <td>1</td><td>Learning Spaces</td><td>45</td>
           </tr>
           <tr>
               <td>2</td><td>Advanced Science Lab<br/>Research Lab/Bio-Tech Lab</td><td>2</td>
           </tr>
           <tr>
               <td>3</td><td>Innovation Lab</td><td>2</td>
           </tr>
           <tr>
               <td>4</td><td>Analytics Center</td><td>2</td>
           </tr>
           <tr>
               <td>5</td><td>Technology Hub</td><td>3</td>
           </tr>
           <tr>
               <td>6</td><td>Learning Resource Center</td><td>2</td>
           </tr>
           <tr>
               <td>7</td><td>Support Facilities</td><td>15</td>
           </tr>
           <tr>
               <td>8</td><td>Research Center</td><td>2</td>
           </tr>
           <tr>
               <td>9</td><td>Creative Studio</td><td>2</td>
           </tr>
           <tr>
               <td>10</td><td>Multipurpose Hall</td><td>1</td>
           </tr>
        </tbody>
               </table>
         </div> */}
         <iframe width="990" height="557" src="https://www.youtube.com/embed/p_DrCFDaxr8" title="SPCS INFRASTRUCTURE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Infrastructure
